import { Env, readFromEnv } from "@cinch-nx/environments";
export var STORYBLOK_BFF_URL = "".concat(readFromEnv(Env.StoryblokBFFComponent));
